// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".remove-margin[data-v-00d27606] {\n  margin-bottom: 0 !important;\n}\n.adjust-margin[data-v-00d27606] {\n  margin-bottom: 0.25rem !important;\n}", ""]);
// Exports
module.exports = exports;
